import { render, staticRenderFns } from "./CharacterForm.vue?vue&type=template&id=33fb5aaf&scoped=true"
import script from "./CharacterForm.vue?vue&type=script&lang=ts"
export * from "./CharacterForm.vue?vue&type=script&lang=ts"
import style0 from "./CharacterForm.vue?vue&type=style&index=0&id=33fb5aaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fb5aaf",
  null
  
)

export default component.exports